<div class="page-container no-scroll">
    <app-header [title]="'time-tracking.indexProjectsPage.title'" [menuService]="menuService"> </app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table [isResponsive]="true" [noPadding]="true" [embedded]="true" [showOffset]="true" [table]="table">
            <app-empty-state
                label="{{
                    (table.isEmpty
                        ? 'time-tracking.myProjectsPage.noProjects'
                        : 'time-tracking.myProjectsPage.noProjectsInFilter'
                    ) | translate
                }}"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
